module.exports = __webpack_public_path__ + "img/ic-trash.578c461f.svg";